import { GrowthBookType } from "@/src/type/growthbook";
import { ObjectHelper } from "../util";

function checkAndMergeVariant(original: any, componentId?: string, variants?: Record<string, GrowthBookType.ContentVariants>) {
  if (!variants || !componentId) {
    return original;
  }

  const variant = variants[componentId];
  if (!variant) {
    return original;
  }
  return ObjectHelper.deepMerge(original, variant.variant);
}

function getVariant(componentId?: string, variants?: Record<string, GrowthBookType.ContentVariants>) {
  if (!variants || !componentId) {
    return null;
  }

  return variants[componentId];
}

function getExperiments(growthBook: GrowthBookType.GrowthBookAndContentVariants) {
  const experiments: Record<string, GrowthBookType.FeatureRule> = {};

  if (!growthBook.features) {
    return experiments;
  }

  for (const [feature, featureDefinition] of Object.entries(growthBook.features)) {
    if (featureDefinition.rules && featureDefinition.rules.length > 0) {
      for (const rule of featureDefinition.rules) {
        if (rule.key) {
          experiments[rule.key] = rule;
        } else {
          const variationLetters = featureDefinition.rules.map((rule) => rule.force ?? "missing");
          const variantMeta = variationLetters.map((variant, index) => ({ key: (index + 1).toString(), name: variant }));
          const meta = [{ key: "0", name: featureDefinition.defaultValue ?? "A" }, ...(variantMeta ?? [])];
          const variations = meta.map((variant) => variant.name);
          experiments[feature] = {
            ...rule,
            key: feature,
            name: feature,
            meta,
            variations,
          };
        }
      }
    }
  }
  return experiments;
}

export default {
  checkAndMergeVariant,
  getVariant,
  getExperiments,
};
